import { Phone, Mail, Clock4, MapPinned } from "lucide-react";
import { renderHTML } from "../../../../utils/text.utils";

export default function ContactInfo({ data }) {
    return (
        <div className="contact-info">
            <h2>Get in Touch</h2>
            <p>Your thoughts matter to us — whether it’s about our products, website experience, or anything else you’d like to share.</p>
            <Info icon={<Phone />} label="Call Us">
                <a href={`tel:${data?.mobile}`}>{data?.mobile}</a>
            </Info>

            <Info icon={<Mail />} label="Send Us a Mail">
                <a href={`mailto:${data?.support_email}`}>{data?.support_email}</a>
            </Info>

            <Info icon={<Clock4 />} label="Opening Time">
                {data?.timing}
            </Info>

            <Info icon={<MapPinned />} label="Address">
                <div dangerouslySetInnerHTML={renderHTML(data?.address)} />
            </Info>
        </div>
    );
}

const Info = ({ icon, label, children }) => (
    <div className="info-item">
        <span>{icon}</span>
        <div>
            <strong>{label}</strong>
            <p style={{ width: "100%" }}>{children}</p>
        </div>
    </div>
);
